(function(ns) {
	"use strict";

	var util = ns.util;

	var rules = {
		name: ["notEmpty", "maxLength:50"],
		kana: ["notEmpty", "maxLength:50"],
		email: ["notEmpty", "email", "maxLength:253"],
		tel: ["notEmpty", "phoneJPFormat", "phoneJPLength"],
		will: ["array_some"],
		interview_date_1: ["notEmpty"],
		interview_time_1: ["notEmpty"],
		interview_date_2: ["notEmpty"],
		interview_time_2: ["notEmpty"],
	};

	util.component("input-view", {
		data: function() {
			return {
				state: ns.store.state,
				entry: ns.store.entry,
				entry_error: ns.store.entry_error,
			}
		},
		methods: {
			complete: function() {
				var me = this,
				errorCount = util.validate(me.entry, rules, me.entry_error);

				if (errorCount === 0) {
					me.$emit("submit");
				} else {
					console.warn("エラーがあります");
					// 描画更新後に実行
					setTimeout(function() {
						var invalidInput = me.$el.querySelector(".is-invalid");
						if (!invalidInput) return;
						BS.Scroll.toElement(invalidInput.parentNode, ns.util.handleErrorOffset());
					});
				}
			},
		},
	});

})(UE);
